import { __extends } from "tslib";
import { RenderTargetWrapper } from "../renderTargetWrapper.js";
/** @hidden */
var WebGPURenderTargetWrapper = /** @class */ (function (_super) {
    __extends(WebGPURenderTargetWrapper, _super);
    function WebGPURenderTargetWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WebGPURenderTargetWrapper;
}(RenderTargetWrapper));
export { WebGPURenderTargetWrapper };
//# sourceMappingURL=webgpuRenderTargetWrapper.js.map